<div fxLayout="column" [style.height]="newHeight">
	<div style="overflow: auto" fxFlex>
		<div #jsonEditor id="jsoneditor" style="height: 100%"></div>
	</div>
</div>

<!--<div style="overflow:auto; height:600px;">
	<div #jsonEditor id="jsoneditor" style="height:100%"></div>
</div>-->
